// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-root[data-v-7975413c]{display:flex;flex-direction:column;height:100vh}.dashboard-content[data-v-7975413c]{display:grid;flex-grow:1;grid-template-areas:\"header\" \"main\";grid-template-columns:auto;grid-template-rows:var(--header-height) auto}.dashboard-content>HEADER[data-v-7975413c]{grid-area:header}MAIN[data-v-7975413c]{grid-area:main;overflow:auto}MAIN .outlet[data-v-7975413c]{min-height:100%;padding:0}", ""]);
// Exports
module.exports = exports;
